/* Sneaker-Vorlage: Empfehlungs-Slider (laedt /recommendations/products oder nutzt Kollektion) */
if (!customElements.get('cfc-recommendations')) {
  customElements.define('cfc-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.cfc__grid')) { this.afterRender(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.io.disconnect();
        this.load();
      }, { rootMargin: '0px 0px 400px 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    load() {
      const url = this.dataset.url + '&product_id=' + this.dataset.productId + '&section_id=' + this.dataset.sectionId;
      fetch(url).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const n = doc.querySelector('cfc-recommendations');
        if (n && n.innerHTML.trim().length) { this.innerHTML = n.innerHTML; this.afterRender(); }
      }).catch((e) => console.error('[cfc-recommendations]', e));
    }
    afterRender() {
      const section = this.closest('.cfc');
      if (section) section.classList.add('cfc--loaded');
      const cards = this.querySelectorAll('[data-cfc-reveal]');
      const obs = new IntersectionObserver((es) => { es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } }); }, { threshold: 0.08 });
      cards.forEach((c) => obs.observe(c));
      this.initArrows();
    }
    initArrows() {
      const section = this.closest('.cfc--slider');
      if (!section) return;
      const track = this.querySelector('.cfc__grid');
      const prev = section.querySelector('.cfc__slider-arrow--prev');
      const next = section.querySelector('.cfc__slider-arrow--next');
      if (!track || !prev || !next) return;
      const box = section.querySelector('.cfc__slider-arrows');
      const step = () => {
        const c = track.querySelector('.cfc__card');
        if (!c) return track.clientWidth * 0.8;
        const st = getComputedStyle(track);
        return c.offsetWidth + (parseFloat(st.columnGap) || parseFloat(st.gap) || 4);
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (box) box.style.visibility = (window.innerWidth >= 750 && track.scrollWidth <= track.clientWidth + 2) ? 'hidden' : '';
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }
  });
}
